import React, { useMemo } from 'react';
import {
    usePlanforhold,
    useArealplanerByNapIds,
    finnErstattendePlaner,
} from '@origo/planregister';
import ReplacementNotice, { type ReplacementPlan } from './ReplacementNotice';

interface ReplacementNoticeContainerProps {
    napId: string;
    ikkeGjeldende: boolean;
    onOpenPlan: (napId: string) => void;
}

const ReplacementNoticeContainer: React.FC<ReplacementNoticeContainerProps> = ({ napId, ikkeGjeldende, onOpenPlan }) => {
    const planforhold = usePlanforhold(napId);
    const erstattende = useMemo(
        () => finnErstattendePlaner(planforhold.data ?? [], napId),
        [planforhold.data, napId]
    );
    const erstattendeIds = useMemo(() => erstattende.map(p => p.nasjonalArealplanId), [erstattende]);
    const erstattendePlaner = useArealplanerByNapIds(erstattendeIds);

    const replacements = useMemo<ReplacementPlan[]>(() => {
        const plannavn = new Map((erstattendePlaner.data ?? []).map(p => [p.nasjonalArealplanId, p.plannavn]));
        return erstattende.map(p => ({
            nasjonalArealplanId: p.nasjonalArealplanId,
            // Bevisst uten ID-fallback: uten navn vises planen uten lenke.
            plannavn: plannavn.get(p.nasjonalArealplanId),
            art: p.art,
        }));
    }, [erstattende, erstattendePlaner.data]);

    return <ReplacementNotice ikkeGjeldende={ikkeGjeldende} replacements={replacements} onOpenPlan={onOpenPlan} />;
};

export default ReplacementNoticeContainer;
